import { VariantTitle } from "../../components/VariantTitle";
import { formatInfoCards } from "./formatInfoCards";
import { filterConfigs, formatCTAS, formatRichText } from "../../functions";
import { PageSectionWrapper } from "../../components/PageSectionWrapper";
import { CTAWrapper } from "../../components/CTA/CTAWrapper";
import { CardContainer } from "./CardContainer";
import { CONFIGURATION_TYPE_IDS, INFO_CARD_VARIANTS } from "../../constants";

export const InfoCardPageSection = ({
	headerText,
	subtitle,
	variant,
	mobileCardContainerType,
	cardContainerType,
	cardVariant,
	siteStatus,
	infoCards,
	variantStyling,
	footer,
	description,
	ctas,
	formattedSectionStyles,
	configurations = [],
	parsedFunctions = {},
	isStatic = false,
}) => {
	const formattedInfoCards = formatInfoCards(infoCards, cardVariant, variantStyling, configurations, siteStatus, parsedFunctions);
	const formattedCtas = formatCTAS(ctas, siteStatus, isStatic);
	const formattedFooter = formatRichText(footer, siteStatus, [], parsedFunctions);
	const textConfiguration = filterConfigs(configurations, CONFIGURATION_TYPE_IDS.RICH_TEXT)?.[0];
	return (
		<>
		{[INFO_CARD_VARIANTS.MODAL_INFO_CARD, INFO_CARD_VARIANTS.BLOG_CARD].includes(cardVariant) ? 
		<CardContainer
			infoCards={formattedInfoCards}
			configurations={configurations}
			mobileCardContainerType={mobileCardContainerType}
			cardContainerType={cardContainerType}
			cardVariant={cardVariant}
		/>
		:
		<PageSectionWrapper variant={variant}>
			{headerText && <VariantTitle title={headerText} subtitle={subtitle} parsedClasses={formattedSectionStyles.headerStyling} />}
			{formatRichText(description, siteStatus)}
			<CardContainer
				infoCards={formattedInfoCards}
				configurations={configurations}
				mobileCardContainerType={mobileCardContainerType}
				cardContainerType={cardContainerType}
				cardVariant={cardVariant}
				ctas={formattedCtas}
			/>
			{formattedFooter && (
				<div
					className={`text-is2-gray-150 text-sm mt-4 m-auto text-center ${formattedSectionStyles.descriptionStyling} ${textConfiguration?.footerStyling}`}
				>
					{formattedFooter}
				</div>
			)}
			{formattedCtas && formattedCtas.length && cardVariant !== INFO_CARD_VARIANTS.SELECTABLE_CARD ? (
				<div className="flex flex-col w-full md:w-1/2 md:flex-row gap-4 mt-[64px] justify-center m-auto">
					{formattedCtas.map((cta, index) => (
						<CTAWrapper key={index} cta={cta} />
					))}
				</div>
			) : null}
		</PageSectionWrapper>}
		</>
	);
};
